<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="part" id="pt01">
<h1 class="pt"><a class="xref" href="#/wsuridl0007#rpt01">The Train Home</a></h1>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// wsu-ridl-0009.vue?41cd1814